// extracted by mini-css-extract-plugin
export default {"container":"jeu_3vS9r"};